export class HeaderVM {
    showCheckbox = true;
}